module.exports = __webpack_public_path__ + "img/teacher-home.3d003f81.svg";